<template lang="pug">
  .promo-banner(v-if='banner')
    a.ga-olr-banner(:href='banner.attributes.link' v-if='hasLink')
      img(:src='banner.attributes.image')
    img(:src='banner.attributes.image' v-else)
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapState } = createNamespacedHelpers('bookingService')

export default {
  name: 'Banner',
  props: ['page', 'customBanner'],
  computed: {
    ...mapState(['banners']),
    banner () {
      const banner = this.customBanner || this.banners.find(banner => banner.attributes.page === this.page)
      return banner || this.banners.find(banner => banner.attributes.page === 'default')
    },
    hasLink () {
      return this.banner.attributes.link !== ''
    }
  },
  mounted () {
    this.fetchBanners()
  },
  methods: {
    ...mapActions(['fetchBanners'])
  }
}
</script>

<style lang='scss'>
  .promo-banner {
    margin-bottom: 20px;
    width: 100%;
    max-height: 80px;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

</style>
